module.exports = __webpack_public_path__ + "static/linkedin logo-6ffea3defe96ee531a103bf10d1096db.png";